<template>
  <section id="contact">
    <card
      v-for="(item, index) in company"
      :key="index"
      :small="true"
      :notAsset="true"
      :image="item.urlToImage"
      :right="index % 2 === 0"
      :portrait="index > 0"
      noZoom
    >
      <section>
        <h3>{{ item.title }}</h3>
        <separator width="190px" backgroundColor="black" height="2px" />
        <div class="contactText" v-html="item.content"/>
        <br>
        <br>
          <custom-button primary center to="/kontakt">Kontakta oss</custom-button>
      </section>
    </card>
    <br>
    <br>
        <instagram-feed />
  </section>
</template>

<script>

import Card from '@/components/Card.vue'
import InstagramFeed from '@/components/InstagramFeed.vue'
import Separator from '@/components/Separator.vue'
import { mapGetters, mapActions } from 'vuex'
import userHandler from './../services/userHandler'
import logFile from '@/script/log'
const log = logFile('company')

export default {
  components: {
    Card,
    Separator,
    InstagramFeed
  },
  data () {
    return {
      company: [],
      question: []
    }
  },
  async created () {
    try {
      this.company = await [
        {
          content: `
        <p>
        NPCPower är en nystartad, nytänkande styrkelyftsklubb i norra norrland. NPCPower är verksam på Nordic Performance Centers (NPCGYMs) anläggningar.
        <br>
        <br>
        Är du intresserad av att lära dig basövningarna, träna med likasinnande och få mer ut av träningen? Vi på NPCPower hjälper dig nå din styrkepotential. Följ länken nedan och ta kontakt med den ansvarige för din anläggning.
        <br>
        <br>
        <br>
        <span style="font-size: 24px; margin-bottom: 5px;">Nuvarande träningstider:</span>
        <br>
        <b>Luleå</b>  <br>
        KOMMER SNART
        <br>
        <br>
        <b>Kiruna</b>
        <br>
        Onsdag: 18:00-20:00
        <br>
        Lördag: 10:00-12:00
        <br>
        <br>
        <b>Boden</b>
        <br>
        Torsdag: 18:00-20:00
        </p>
        `,
          description: '',
          title: 'NPC Power Club',
          urlToImage: 'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Flogos%2FNPCPowerLogo.png?alt=media'
        }
      ]

      this.company.forEach(staff => {
        this.question.push(
          {
            sending: false,
            question: '',
            email: ''
          }
        )
      })
    } catch (err) {
      this.error = err
      this.company = []
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'flags']),
    questionFlag () {
      return this.flags['question']
    }
  },
  mounted () {
    userHandler.getInstagramPosts()
  },
  methods: {
    ...mapActions(['setFlag']),
    sendQuestion (index) {
      this.question[index].sending = true
      userHandler
        .sendAQuestion(this.question[index])
        .then(response => {
          this.question[index].sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 1,
              msg: 'Frågan har skickats!'
            }
          })
        })
        .catch(err => {
          this.question[index].sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 2,
              msg: 'Ett fel inträffade, försök igen.'
            }
          })
          log.error(err)
        })
    },
    status (validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';
#contact {
  padding-top: 90px;
  margin-top: 10px;
  max-width: 1200px;
  margin: 0 auto;
}
.alt-link {
  color: @color-secondary-dark;
}
.contactText {
  font-size: 18px;
  line-height: 1.3;
}
</style>
